import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ValidationErrors } from '@angular/forms';
import { User } from 'src/app/models/user.model';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { APIResponse } from 'src/app/models/api-response.model';
import {timer, Observable} from 'rxjs';
import {map, switchMap, first} from 'rxjs/operators';
import { debounce } from 'rxjs/operators';


@Component({
  selector: 'ubc-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.scss']
})
export class UsersPageComponent implements OnInit {

  constructor(private apiService: APIServiceService) { }
  createUserForm: UntypedFormGroup;

  ngOnInit() {
    this.configCreateUserForm();
  }

  configCreateUserForm() {
    this.createUserForm = new UntypedFormGroup({
      firstName : new UntypedFormControl(null, Validators.required),
      lastName : new UntypedFormControl(null, Validators.required),
      email : new UntypedFormControl(null, [Validators.required, Validators.email], [this.checkEmailAvailability.bind(this)])
    });
  }

  createUserSubmit() {
    const user: User = new User().deserialize(
      {
        firstName : this.createUserForm.value.firstName,
        lastName : this.createUserForm.value.lastName,
        email : this.createUserForm.value.email
      }
    );
    this.apiService.user.create(user)
    .then((response: APIResponse) => {
      console.log(response);
    })
    .catch((err) => {
      console.log(err);
    });
  }


  checkEmailAvailability(control: UntypedFormControl): Observable<any> {
    return control.valueChanges.pipe(
      debounce(() => timer(500)),
      first(),
      switchMap(() => {
        return this.apiService.user.isEmailtaken(this.createUserForm.get('email').value)
        .pipe(
          map((
            (response) => {
              if(response.data.isAvailable) {
                console.log('EMAIL IS AVAILABLE')
                return null;
              }
              console.log('EMAL IS TAKEN');
              return { emailIsInUse: true };
            }
            )
        ));
      })
    );
  }





}
